// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Tenant  {
    _originalTypeClassName = "LoomTenantManagement.BO.Tenant";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Tenant.translate = translateService;
}
this.TenantSettings = [];
this.EnabledLoomModules = [];
this.Id = null;
this.Name = null;
this.DomainName = null;
this.CreationDate = null;
this.ExpirationDate = null;
this.CreatedBy = null;
this.Status = null;
this.Notes = null;
this._key = this.Id = "00000000-0000-0000-0000-000000000000"; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
DomainName:any;
CreationDate:any;
ExpirationDate:any;
CreatedBy:any;
Status:any;
Notes:any;
ContactInfo:any;
Subscription:any;
TenantSettings:any;
EnabledLoomModules:any;
DatabaseSettings:any;
Deployment:any;
static setContactInfo = ($this, value) => {
var oldValue = $this.ContactInfo;
$this.ContactInfo = value;
if (value != null) {
}
}
static setSubscription = ($this, value) => {
var oldValue = $this.Subscription;
$this.Subscription = value;
if (value != null) {
}
}
static setTenantSettings = ($this, items) => {
                if (items == null) items = [];
                if ($this.TenantSettings == null) $this.TenantSettings = [];

                const copyItems = Common.cloneObject(items);

                while ($this.TenantSettings.length > 0) {
                    Domain.Tenant.removeTenantSettings($this, $this.TenantSettings[0]);
                }

                Domain.Tenant.addManyTenantSettings($this, copyItems);
            }
static addManyTenantSettings = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Tenant.addTenantSettings($this, items[i]);
                }
            }
static addTenantSettings = ($this, item) => {
                if ($this.TenantSettings == null) $this.TenantSettings = [];
                if (item == null || $this.TenantSettings.indexOf(item) > -1) return;
                $this.TenantSettings.push(item);
if (item.Tenant != $this) {
Domain.TenantSetting.setTenant(item, $this);
}
}
static addRangeTenantSettings = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Tenant.addTenantSettings($this, item));
            }
static removeTenantSettings = ($this, item) => {
                if ($this == null || $this.TenantSettings == null || $this.TenantSettings.indexOf(item) === -1) return;
                var _index = $this.TenantSettings.indexOf(item);
                $this.TenantSettings.splice(_index, 1);
item.Tenant = null;
}
static clearTenantSettings = ($this) => { $this.TenantSettings = null; }
static setEnabledLoomModules = ($this, items) => {
                if (items == null) items = [];
                if ($this.EnabledLoomModules == null) $this.EnabledLoomModules = [];

                const copyItems = Common.cloneObject(items);

                while ($this.EnabledLoomModules.length > 0) {
                    Domain.Tenant.removeEnabledLoomModules($this, $this.EnabledLoomModules[0]);
                }

                Domain.Tenant.addManyEnabledLoomModules($this, copyItems);
            }
static addManyEnabledLoomModules = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Tenant.addEnabledLoomModules($this, items[i]);
                }
            }
static addEnabledLoomModules = ($this, item) => {
                if ($this.EnabledLoomModules == null) $this.EnabledLoomModules = [];
                if (item == null || $this.EnabledLoomModules.indexOf(item) > -1) return;
                $this.EnabledLoomModules.push(item);
if (item.Tenant != $this) {
Domain.EnabledLoomModule.setTenant(item, $this);
}
}
static addRangeEnabledLoomModules = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Tenant.addEnabledLoomModules($this, item));
            }
static removeEnabledLoomModules = ($this, item) => {
                if ($this == null || $this.EnabledLoomModules == null || $this.EnabledLoomModules.indexOf(item) === -1) return;
                var _index = $this.EnabledLoomModules.indexOf(item);
                $this.EnabledLoomModules.splice(_index, 1);
item.Tenant = null;
}
static clearEnabledLoomModules = ($this) => { $this.EnabledLoomModules = null; }
static setDatabaseSettings = ($this, value) => {
var oldValue = $this.DatabaseSettings;
$this.DatabaseSettings = value;
if (value != null) {
}
}
static setDeployment = ($this, value) => {
var oldValue = $this.Deployment;
$this.Deployment = value;
if (value != null) {
if (oldValue != null && oldValue.Tenant != null) { oldValue.Tenant = null; }
if ($this.Deployment.Tenant !== $this) {
Domain.DeploymentSettings.setTenant(value, $this);
}
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == "00000000-0000-0000-0000-000000000000";
            }


}